import React from "react";
import styles from "./PageLoader.module.scss";

const PageLoader = ({ text = "Loading...", fullScreen = false }) => {
  return (
    <div className={`${styles.container} ${fullScreen ? styles.fullScreen : styles.inline}`}>
      <div className={styles.loaderBox}>
        {/* Animated Fitness Bodybuilder Lifting Dumbbells */}
        <div className={styles.fitnessWrapper}>
          <svg
            className={styles.bodybuilderSvg}
            viewBox="0 0 200 200"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Pulsing Backlight Glow */}
            <circle cx="100" cy="100" r="70" className={styles.glowCircle} />

            {/* Head */}
            <circle cx="100" cy="55" r="18" fill="#1e293b" />
            <path
              d="M90 40C93 37 107 37 110 40C110 40 106 48 100 48C94 48 90 40 90 40Z"
              fill="#38bdf8"
            />

            {/* Torso & Muscle Tank */}
            <path
              d="M72 82C72 75 80 72 100 72C120 72 128 75 128 82L120 145C118 152 108 156 100 156C92 156 82 152 80 145L72 82Z"
              fill="url(#torsoGradient)"
            />
            {/* Chest & Muscle Detailing */}
            <path
              d="M82 92C92 98 108 98 118 92"
              stroke="#ffffff"
              strokeWidth="3"
              strokeLinecap="round"
              opacity="0.8"
            />
            <path
              d="M100 95V135"
              stroke="#ffffff"
              strokeWidth="2"
              strokeLinecap="round"
              opacity="0.5"
            />

            {/* LEFT ARM & DUMBBELL (Animated) */}
            <g className={styles.leftArmGroup}>
              {/* Biceps & Forearm */}
              <path
                d="M75 82Q52 75 42 55Q38 45 32 50Q28 58 40 78Q55 98 75 92Z"
                fill="#f97316"
              />
              {/* Left Dumbbell */}
              <g transform="translate(30, 48)">
                <rect x="-16" y="-6" width="32" height="12" rx="3" fill="#334155" />
                <rect x="-22" y="-12" width="8" height="24" rx="2" fill="#0f172a" />
                <rect x="14" y="-12" width="8" height="24" rx="2" fill="#0f172a" />
                <circle cx="-18" cy="0" r="3" fill="#38bdf8" />
                <circle cx="18" cy="0" r="3" fill="#38bdf8" />
              </g>
            </g>

            {/* RIGHT ARM & DUMBBELL (Animated) */}
            <g className={styles.rightArmGroup}>
              {/* Biceps & Forearm */}
              <path
                d="M125 82Q148 75 158 55Q162 45 168 50Q172 58 160 78Q145 98 125 92Z"
                fill="#f97316"
              />
              {/* Right Dumbbell */}
              <g transform="translate(170, 48)">
                <rect x="-16" y="-6" width="32" height="12" rx="3" fill="#334155" />
                <rect x="-22" y="-12" width="8" height="24" rx="2" fill="#0f172a" />
                <rect x="14" y="-12" width="8" height="24" rx="2" fill="#0f172a" />
                <circle cx="-18" cy="0" r="3" fill="#38bdf8" />
                <circle cx="18" cy="0" r="3" fill="#38bdf8" />
              </g>
            </g>

            {/* Ground Shadow */}
            <ellipse cx="100" cy="175" rx="45" ry="6" fill="#000000" opacity="0.15" className={styles.shadowEllipse} />

            {/* Gradients */}
            <defs>
              <linearGradient id="torsoGradient" x1="72" y1="72" x2="128" y2="156" gradientUnits="userSpaceOnUse">
                <stop stopColor="#0d9488" />
                <stop offset="1" stopColor="#0284c7" />
              </linearGradient>
            </defs>
          </svg>
        </div>

        {/* Loading Text & Animated Dots */}
        <div className={styles.textWrapper}>
          <p className={styles.loadingText}>{text}</p>
          <div className={styles.progressPulse}>
            <div className={styles.progressBar} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
